export default __webpack_public_path__ + "static/media/Necklace of the Manic Haze.27dd38ab.jpg";